import styled from "styled-components";
import {Space} from "antd";

export const SnippetExtras = styled(Space)`
  margin: auto 0 auto auto;
  & > .ant-button {
    cursor: pointer !important;
  }
`
